<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="3">
        <YearsComponent @change="onYearSelected" />
      </el-col>
      <el-col :span="3">
        <MonthsComponent @change="OnMonthSelected" />
      </el-col>
      <el-col :span="3">
        <PaymentAndInvoiceTypeSelector
          @PaymentTypeSelected="OnPaymentTypeSelected"
        />
      </el-col>
      <el-col :span="3">
        <PaymentAndInvoicePaid @OnExecutionSelected="OnExecutionSelected" />
      </el-col>
      <el-col :span="3">
        <PaymentsAndInvoicesSelector @PaymentSelected="OnPaymentSelected" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import YearsComponent from "@/components/Global_System/YearsComponent";
import MonthsComponent from "@/components/Global_System/MonthsComponent";
import PaymentsAndInvoicesSelector from "@/components/fiances/reports/filters/PaymentsAndInvoicesSelector";
import PaymentAndInvoiceTypeSelector from "@/components/fiances/reports/filters/PaymentAndInvoiceTypeSelector";
import PaymentAndInvoicePaid from "@/components/fiances/reports/filters/PaymentAndInvoicePaid";

export default {
  name: "ClientRabbeyPaymentAndInvoicingReportFilters",
  components: {
    YearsComponent,
    MonthsComponent,
    PaymentsAndInvoicesSelector,
    PaymentAndInvoiceTypeSelector,
    PaymentAndInvoicePaid
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {
    onYearSelected(year) {
      this.$emit("onYearSelected", year);
    },
    OnMonthSelected(month) {
      this.$emit("onMonthSelected", month);
    },
    OnPaymentTypeSelected(value) {
      this.$emit("onPaymentTypeSelected", value);
    },
    OnExecutionSelected(value) {
      this.$emit("ExecutionSelected", value);
    },
    OnPaymentSelected(value) {
      this.$emit("PaymentSelected", value);
    }
  }
};
</script>

<style scoped></style>
